'use client';

import { useEffect, useState } from 'react';

import { Banner } from '../Banner/Banner';
import { Stack } from '../Stack/Stack';
import { useIsPageOwner } from '../../hooks/useIsPageOwner';
import { useTranslation } from 'react-i18next';

const storageKey = 'JG.Pages.Edge_NewInMemPageBannerDismissed';

export const NewInMemPageBanner = () => {
  const [isDismissed, setDismissed] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    setDismissed(localStorage.getItem(storageKey) === 'true');
  }, []);

  const isPageOwner = useIsPageOwner();

  function handleDismissClick() {
    localStorage.setItem(storageKey, 'true');
    setDismissed(true);
  }

  if (isDismissed || !isPageOwner) {
    return null;
  }

  return (
    <Banner>
      <Banner.Content>
        <Stack
          direction="row"
          gap="sizeSpacing03"
          flex={1}
          justifyContent="center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M10.95 13.0654L9.3269 11.4577C9.18845 11.3193 9.01698 11.2484 8.8125 11.2452C8.60801 11.242 8.42821 11.318 8.2731 11.4731C8.12821 11.618 8.05577 11.7936 8.05577 12C8.05577 12.2064 8.12821 12.382 8.2731 12.5269L10.3173 14.5711C10.4981 14.7519 10.709 14.8423 10.95 14.8423C11.191 14.8423 11.4019 14.7519 11.5827 14.5711L15.7269 10.4269C15.8756 10.2782 15.949 10.1042 15.9471 9.9048C15.9452 9.70545 15.8718 9.52822 15.7269 9.3731C15.5718 9.21797 15.3936 9.13783 15.1923 9.1327C14.991 9.12758 14.8128 9.20258 14.6577 9.3577L10.95 13.0654ZM8.40962 21.1827L7.02695 18.8577L4.41157 18.2961C4.1872 18.2525 4.00804 18.1346 3.87407 17.9423C3.7401 17.75 3.68658 17.5416 3.7135 17.3173L3.96927 14.6269L2.19042 12.5923C2.03659 12.4282 1.95967 12.2308 1.95967 12C1.95967 11.7692 2.03659 11.5718 2.19042 11.4077L3.96927 9.3731L3.7135 6.68273C3.68658 6.45836 3.7401 6.25003 3.87407 6.05773C4.00804 5.86541 4.1872 5.74746 4.41157 5.70388L7.02695 5.14235L8.40962 2.81735C8.53014 2.61992 8.69425 2.4853 8.90195 2.4135C9.10963 2.34172 9.32052 2.35262 9.53462 2.4462L12 3.4885L14.4654 2.4462C14.6795 2.35262 14.8904 2.34172 15.098 2.4135C15.3057 2.4853 15.4699 2.61992 15.5904 2.81735L16.973 5.14235L19.5884 5.70388C19.8128 5.74746 19.992 5.86541 20.1259 6.05773C20.2599 6.25003 20.3134 6.45836 20.2865 6.68273L20.0307 9.3731L21.8096 11.4077C21.9634 11.5718 22.0403 11.7692 22.0403 12C22.0403 12.2308 21.9634 12.4282 21.8096 12.5923L20.0307 14.6269L20.2865 17.3173C20.3134 17.5416 20.2599 17.75 20.1259 17.9423C19.992 18.1346 19.8128 18.2525 19.5884 18.2961L16.973 18.8577L15.5904 21.1827C15.4699 21.3801 15.3057 21.5147 15.098 21.5865C14.8904 21.6583 14.6795 21.6474 14.4654 21.5538L12 20.5115L9.53462 21.5538C9.32052 21.6474 9.10963 21.6583 8.90195 21.5865C8.69425 21.5147 8.53014 21.3801 8.40962 21.1827ZM9.45 19.95L12 18.8692L14.5808 19.95L16 17.55L18.75 16.9192L18.5 14.1L20.35 12L18.5 9.86923L18.75 7.05L16 6.45L14.55 4.05L12 5.13078L9.41922 4.05L8 6.45L5.25 7.05L5.5 9.86923L3.65 12L5.5 14.1L5.25 16.95L8 17.55L9.45 19.95Z"
              fill="#252B33"
            />
          </svg>
          <div>
            <span>{t('inMemoryTeam.newExperience')}</span>{' '}
            <a
              className="cp-text-link"
              href="https://justgiving-charitysupport.zendesk.com/hc/en-us/articles/14536963280273-Creating-an-In-memory-fundraising-or-donation-page"
              rel="noopener noreferrer"
              onClick={handleDismissClick}
              target="_blank"
            >
              {t('learnMore')}
            </a>
          </div>
        </Stack>
      </Banner.Content>
      <Banner.CloseButton
        aria-label={t('close') ?? 'close'}
        onClick={() => {
          localStorage.setItem(storageKey, 'true');
          setDismissed(true);
        }}
      />
    </Banner>
  );
};
